import store from '@/store';

import {
  MODEL_TYPES,
  MODEL_TO_STATE,
} from '@/lib/constants/model-types';

export default (modelType, modelId, propertyName) => {
  if (MODEL_TYPES.includes(modelType)) {
    const { state } = store;
    const model = state[MODEL_TO_STATE[modelType]];
    const hasModelId = Object.prototype.hasOwnProperty.call(model, modelId);
    if (hasModelId) {
      const modelObj = model[modelId];
      const hasProperty = Object.prototype.hasOwnProperty.call(modelObj, propertyName);
      if (hasProperty) {
        return modelObj[propertyName];
      }
    }
  }
  return undefined;
};
